<template>
    <modal :show.sync=show modalClasses="modal-hide-footer">
        <h3 slot="header" class="mb-0 font-weight-500">Historical Enquiry</h3>
        <b-row>
            <b-col cols="12">
                <div v-if="tableData.length > 0" class="historical-enquiry rounded-bottom">
                        <el-table :data="pivotHistoricalEnquiry" border style="width: 100%" :span-method="tableSpanMethod" class="historical-enquiry-table">
                      <el-table-column prop="year" label="Year" width="80" align="center" header-align="center"/>
                      <el-table-column prop="rowType" label="Type" width="100" align="center" header-align="center"/>
                      <el-table-column
                        v-for="m in monthNames"
                        :key="m"
                        :prop="m"
                        :label="m"
                        align="center"
                        header-align="center"
                      />
                    </el-table>
                </div>
                <div v-else class="bg-light p-3 text-center rounded-bottom">
                  <p class="text-xs">No Historical enquiries recorded</p>
                </div>
            </b-col>
        </b-row>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "HistoricalEnquiryModal",
  props: {
    historicalEnquiry: Array,
    show_history_full_view: Boolean
  },
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tableData: this.historicalEnquiry,
      monthNames: [
        "Jan","Feb","Mar","Apr","May","Jun",
        "Jul","Aug","Sep","Oct","Nov","Dec"
      ]
    };
  },
  computed: {
    show: {
      get() {
        return this.show_history_full_view;
      },
      set(value) {
        this.$emit("update:show_history_full_view", value);
      }
    },
    pivotHistoricalEnquiry() {
      if (!this.historicalEnquiry) return [];

      const rows = [];

      this.historicalEnquiry.forEach(yearBlock => {
        const year = yearBlock["@attributes"]?.year;

        const rowFI = { year, rowType: "FI" };
        const rowNonFI = { year, rowType: "Non-FI" };
        const rowLawyer = { year, rowType: "Lawyer" };
        const rowTotal = { year, rowType: "Total" };

        yearBlock.period.forEach(period => {
          const monthIdx = parseInt(period["@attributes"]?.month, 10) - 1;
          const monthName = this.monthNames[monthIdx];

          let fi = 0, nonfi = 0, lawyer = 0;
          period.entity.forEach(e => {
            const type = e["@attributes"]?.type;
            const val = parseInt(e["@attributes"]?.value || 0, 10);
            if (type === "FI") fi = val;
            if (type === "NON-FI") nonfi = val;
            if (type === "LAWYER") lawyer = val;
          });

          rowFI[monthName] = fi;
          rowNonFI[monthName] = nonfi;
          rowLawyer[monthName] = lawyer;
          rowTotal[monthName] = fi + nonfi + lawyer;
        });

        rows.push(rowFI, rowNonFI, rowLawyer, rowTotal);
      });

      return rows;
    }
  },
  methods: {
    tableSpanMethod({ column, rowIndex }) {
      if (column.property === "year") {
        if (rowIndex % 4 === 0) {
          return [4, 1];
        } else {
          return [0, 0];
        }
      }
    }
  }
};
</script>

<style scoped>
::v-deep .historical-enquiry-table .el-table__header {
  background-color: #252938 !important;
}

::v-deep .historical-enquiry-table .el-table__header th {
  background-color: #252938 !important;
  color: #fff !important;
  border: none !important;
  vertical-align: top !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  padding: 9px 12px !important;
}

::v-deep .historical-enquiry-table .el-table__header th .cell {
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  text-transform: none !important;
}

::v-deep .historical-enquiry-table .el-table__header-wrapper {
  background-color: #252938 !important;
}
</style>